<template>
  <div class="general-frame">
    <div class="general-neick">
      <div class="general-search-bar">
        <el-button
          type="primary"
          class="elm-but"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
        >返回列表
        </el-button>
        <span>用户名：</span>
        <el-input
          v-model="userName"
          @input="getList()"
          placeholder="请输入用户名"
          style="width:250px;margin:0px 10px"
        ></el-input>
        <el-button
          v-if="global.power('usermgr.add') == true"
          type="primary"
          class="elm-but"
          @click="popup = 1;popupName ='新增人员'"
        >新增人员
        </el-button>
        <el-button
          type="primary"
          class="elm-but"
          style="margin-left:15px"
          :loading="loading"
          @click="userName='',getList()"
        >重置
        </el-button>
      </div>
      <div>
        <table class="surface">
          <thead>
          <tr>
            <th>用户名</th>
            <th>真实姓名</th>
            <th>公司</th>
            <th>性别</th>
            <th>电话</th>
            <th style="width: 400px;">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in  data" :key="index">
            <td>{{ item.userName }}</td>
            <td>{{ item.realName != null ? item.realName : "暂无" }}</td>
            <td>{{ transformation(item.companyId) }}</td>
            <td>{{ item.sex == 'male' ? '男' : '女' }}</td>
            <td>{{ item.telPhone != null ? item.telPhone : "暂无" }}</td>
            <td class="color_button">
              <div v-if="item.id == user.id || user.userType == 'admin' ">
                <span
                  @click="edit(item)"
                  v-if="global.power('usermgr.update') == true"
                  class="margin-but"
                >
                  <i class="el-icon-edit"></i>编辑
                </span>
                <span
                  @click="resetPassword(item.id)"
                  v-if="global.power('usermgr.resetpwd') == true"
                  class="margin-but"
                >
                  <i class="el-icon-refresh"></i>重置密码
                </span>
                <span
                  @click="deleteAccount(item.id)"
                  style="color:#f56c6c"
                  v-if="global.power('usermgr.cancel') == true"
                  class="margin-but"
                >
                  <i class="el-icon-delete"></i>删除
                </span>
              </div>
            </td>
          </tr>
          </tbody>
          <noData :data="data"/>
        </table>
        <el-pagination
          background
          style="text-align: center;margin-top:15px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum "
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增编辑 -->
    <div class="window" v-show="popup == 1">
      <div style="width:50%;background:#FFF;border-radius: 4px;">
        <div class="window_top">
          <span>{{ popupName }}</span>
          <i class="el-icon-close" @click="popup = 0;eliminate()"></i>
        </div>
        <div style="padding: 20px;">
          <el-form
            :label-position="labelPosition"
            label-width="80px"
            ref="form"
            :model="form"
            :rules="formFules"
            style="display: flex;justify-content: space-between;"
          >
            <div style="width: 45%;">
              <el-form-item
                label="用户名"
                prop="userName"
                :rules="[{ required: true, message: '请输入用户名' }]"
              >
                <el-input placeholder="请输入用户名" v-model="form.userName"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="telPhone">
                <el-input placeholder="请输入电话" v-model="form.telPhone"></el-input>
              </el-form-item>
              <el-form-item
                label="所属公司"
                prop="companyId"
                :rules="[{ required: true, message: '请选择所属公司' }]"
              >
                <el-select v-model="form.companyId" style="width: 100%">
                  <el-option
                    v-for="item in operationList"
                    :key="item.value"
                    :label="item.companyName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="用户类型"
                prop="userType"
                :rules="[{ required: true, message: '请选择用户类型' }]"
              >
                <el-select v-model="form.userType" style="width: 100%">
                  <el-option label="运维管理人员" value="operatorMgr"></el-option>
                  <el-option label="运维实施人员" value="operatorAction"></el-option>
                  <el-option label="运维保洁人员" value="operatorCleaner"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="width: 48%;">
              <el-form-item
                label="真实姓名"
                prop="realName"
                :rules="[{ required: true, message: '请输入用户名' }]"
              >
                <el-input placeholder="请输入用户名" v-model="form.realName"></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="sex" :rules="[{ required: true, message: '请选择性别' }]">
                <el-select v-model="form.sex" style="width: 100%">
                  <el-option label="男" value="male"></el-option>
                  <el-option label="女" value="female"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="身份证号" prop="idNumber">
                <el-input v-model="form.idNumber" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="window_bottom">
          <el-button type="primary" @click="submit('form')">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import noData from "@/components/html/noData";

export default {
  components: {
    noData,
  },
  data() {
    return {
      formFules: {
        telPhone: [
          {
            validator: function (rule, value, callback) {
              if (/^1[34578]\d{9}$/.test(value) == false && value != "") {
                callback(new Error("手机号格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        idNumber: [{
          validator: function (rule, value, callback) {
            if (/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(value) == false && value != "") {
              callback(new Error("身份证格式错误"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        }],
      },
      pageSize: 10, //每页10条
      pageNum: 1, //当前页码
      total: 0,
      user: {},
      popupName: "新增人员",
      userName: "",
      labelPosition: "right",
      data: null,
      operationList: [],
      loading: false,
      popup: 0,
      form: {
        sex: "",
        telPhone: "",
        userName: "",
        realName: "",
        companyId: "",
        idNumber: "",
        userType: "",
        id: null,
      },
      ruleForm: {
        oldPass: "",
        newPass: "",
        newPassWord: "",
      },
    };
  },
  methods: {
    //列表
    getList() {
      this.get("user/getPageList", {
        userName: this.userName,
        companyId: this.$route.query.id,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }).then((res) => {
        this.data = res.data.rows;
        this.total = res.data.total;
      });
    },

    //公司-用户
    getOperation() {
      this.get("/operation/operational/allList", {}).then((res) => {
        this.operationList = res.data.rows;
      });
    },

    //pageNum  改变时会触发
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(); //调用终端数据接口
    },
    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },

    //查询公司名称
    transformation(val) {
      if (this.operationList != []) {
        var data = this.operationList.filter((item) => {
          return item.id == val;
        });
        return data[0].companyName;
      }
    },

    //清除form信息
    eliminate() {
      this.form.id = null;
      this.$refs.form.resetFields();
    },

    //修改密码
    changePassword(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.ruleForm.newPass === this.ruleForm.newPassWord) {
            this.post("user/changePassword", {
              password: this.ruleForm.oldPass,
              passwordNew: this.ruleForm.newPassWord,
            }).then((res) => {
              if (res.data.data != true) {
                this.$message.error(res.data.returnMsg);
              } else {
                this.$message({
                  message: "密码修改成功，请您重新登录",
                  type: "success",
                });
                this.$refs.ruleForm.resetFields();
                window.localStorage.clear();
                this.$router.push({path: "/"});
              }
            });
          } else {
            this.$message.error("确认密码必须与新密码保持一致");
          }
        }
      });
    },

    //编辑
    edit(item) {
      this.popup = 1;
      this.popupName = "编辑人员";
      this.form.id = item.id;
      this.form.sex = item.sex;
      this.form.telPhone = item.telPhone;
      this.form.userName = item.userName;
      this.form.realName = item.realName;
      this.form.companyId = item.companyId;
      this.form.idNumber = item.idNumber;
      this.form.userType = item.userType.toString();
    },

    //提交
    submit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.popupName === "编辑人员") {
            this.post("user/update", this.form).then((res) => {
              if (res.data.code == 200) {
                this.getList();
                this.popup = 0;
                this.eliminate();
                this.$message({
                  type: "success",
                  message: "修改成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
          } else {
            this.post("user/add", this.form).then((res) => {
              if (res.data.code == 200) {
                this.getList();
                this.popup = 0;
                this.eliminate();
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },

    //重置密码
    resetPassword(id) {
      this.$confirm("是否重置密码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.post("user/resetPassword", {
          id: id,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "密码重置成功!",
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
      .catch(() => {
      });
    },

    //删除账号
    deleteAccount(id) {
      this.$confirm("是否删除??", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.post("user/delete", {
          id: id,
        }).then((res) => {
          if (res.data.code == 200) {
            this.getList();
            this.$message({
              message: "删除成功!",
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
      .catch(() => {
      });
    },
  },
  mounted() {
    this.getList();
    this.getOperation();
    this.user = JSON.parse(localStorage.getItem("data"));
  },
  created: function () {
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/menu/maintenance/companyDetails.vue